import axiosIns from '../../../../xaxios';
import { obtenerUrlAPIReporteDocente } from '../utils/funciones';

const recurso = 'reporte-docente';

export default {
  async controlPagoDocentePorEmpresa(params) {
    return await axiosIns.get(obtenerUrlAPIReporteDocente(`${recurso}/control-pago-docente-por-empresa`), { params });
  },

  async controlDetalladoPagoDocentePorSede(params) {
    return await axiosIns.get(obtenerUrlAPIReporteDocente(`${recurso}/control-detallado-pago-docente-por-sede`), { params });
  },

  async controlPagoDocentePorEmpresaExcel(params) {
    return await axiosIns.get(obtenerUrlAPIReporteDocente(`${recurso}/control-pago-docente-por-empresa-excel`), {
      params,
      responseType: 'blob',
    });
  },

  async controlDetalladoPagoDocentePorSedeExcel(params) {
    return await axiosIns.get(obtenerUrlAPIReporteDocente(`${recurso}/control-detallado-pago-docente-por-sede-excel`), {
      params,
      responseType: 'blob',
    });
  },

  async getUnidadSede() {
    return await axiosIns.get(obtenerUrlAPIReporteDocente('roles/unidad-sede'));
  },
};
